module.exports = __webpack_public_path__ + "static/media/hinted-Whitney-Black.c6e50fc9.ttf";